import { Button } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import React from 'react';

export default function CustomButton({
  type,
  label,
  onClick,
  disabled,
  tooltipText,
  variant = 'contained',
  fullWidth,
  sx,
  className,
  endIcon
}: {
  type?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  label: string | JSX.Element;
  onClick: () => void;
  disabled?: boolean;
  tooltipText?: string;
  variant?: 'text' | 'contained' | 'outlined';
  fullWidth?: boolean;
  sx?: SxProps<Theme>;
  className?: string;
  endIcon?: React.ReactNode;
}) {
  return (
    <Button
      className={className}
      color={type || 'primary'}
      disabled={disabled}
      onClick={onClick}
      variant={variant}
      title={tooltipText || ''}
      sx={{ marginRight: '5px', ...sx }}
      fullWidth={fullWidth}
      endIcon={endIcon}>
      {label}
    </Button>
  );
}
